import { render } from "@/components/pages/dataRecollection/workSupport/WorkSupportPage146.html?vue&type=template&id=3e023294&scoped=true&external"
import script from "@/components/pages/dataRecollection/workSupport/WorkSupportPage146.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/workSupport/WorkSupportPage146.js?vue&type=script&lang=js&external"

import "@/components/pages/dataRecollection/workSupport/WorkSupportPage146.scss?vue&type=style&index=0&id=3e023294&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e023294"]])

export default __exports__